import { createSelector } from "reselect";
const selector = (state) => state.users;

export default createSelector([selector], (data) => data);